import { useQuery } from "@tanstack/react-query";

const urlServicio = process.env.REACT_APP_URL_DIR + "Servicio";

export function GetServicios() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["servicio"],
      queryFn: () =>
         fetch(urlServicio, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}

export default GetServicios;
